import React, { useState } from 'react'

const TextBox = ({ onSendMessage }) => {
    const [message, setMessage] = useState('')

    // Fonction pour gérer le changement de texte
    const handleChange = (event) => {
        setMessage(event.target.value)
    }

    // Fonction pour envoyer le message
    const handleSend = () => {
        if (message.trim() === '') return // Empêche l'envoi d'un message vide
        onSendMessage(message) // Appelle la fonction de l'appelant pour traiter le message
        setMessage('') // Réinitialise le champ de saisie
    }

    // Gère l'envoi avec la touche "Entrée"
    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault() // Empêche le retour à la ligne
            handleSend()
            setMessage('')
        }
    }

    return (
        <div className="text-box">
            <textarea
                className="text-input"
                value={message}
                onChange={handleChange}
                onKeyPress={handleKeyPress}
                placeholder="Écrivez votre message..."
                rows="3"
            />
            <button className="send-button" onClick={handleSend}>
                Envoyer
            </button>
        </div>
    )
}

export default TextBox
